import { FC } from "react";
import { useNotify, useRefresh, useUnselectAll } from "react-admin";

import { firestore } from "../../../init/firebase";
import ConfirmationPopover from "../../../components/ConfirmationPopover";
import { AppResource } from "../../../types/resource.types";

const DeleteUserGuideButton: FC<any> = ({ selectedIds }: Record<string, any>) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();

  const disableProperty = async () => {
    try {
      const batch = firestore.batch();
      Array.isArray(selectedIds) &&
        selectedIds.forEach((id: string) => {
          batch.delete(firestore.collection(AppResource.userGuide).doc(id));
        });
      await batch.commit();
      notify("User Guides have been deleted", "success");
      unselectAll(AppResource.userGuide);
      refresh();
    } catch (ex: any) {
      console.log(ex.message);
      notify("Error on deleting user guide", "error");
    }
  };

  return (
    <ConfirmationPopover
      onConfirm={disableProperty}
      buttonText="Delete"
      message="Are you sure you want to delete user guide?"
    />
  );
};

export default DeleteUserGuideButton;
